import * as React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import "./RaikoDrawer.scss"
import {Drawer} from "@mui/material";

type DrawerDirection = {
    anchor: "left" | "right" | "top" | "bottom";
    className: string;
};


export const RaikoDrawerDirection = {
    "RIGHT": {
        anchor: "left",
        className: "rightDrawerBox"
    },
    "LEFT": {
        anchor: "right",
        className: "leftDrawerBox"
    },
    "BOTTOM": {
        anchor: "bottom",
        className: "bottomDrawerBox"
    },
    "TOP": {
        anchor: "top",
        className: "topDrawerBox"
    }
} as const;


interface RaikoDrawerProps {
    anchor: DrawerDirection,
    onClose?: () => void;
    onOpen?: () => void;
    openDrawer: boolean;
    children?: React.ReactNode;
    className?: string;
    containerId?: string;
}

const RaikoDrawer: React.FC<RaikoDrawerProps> = (
    {
        anchor = RaikoDrawerDirection.BOTTOM,
        onClose,
        onOpen,
        openDrawer,
        children,
        className,
        containerId

    }) => {


    const container = () => document.getElementById("basePageContainerId");


    return (
        <div className={`drawerBaseContainer ${className}`}>
            <Drawer
                anchor={anchor.anchor}
                open={openDrawer}
                onClose={onClose}
                // onOpen={onOpen}
                container={container}
            >
                <div className={anchor.className}>
                    {children}
                </div>
            </Drawer>

        </div>
    );
}
export default RaikoDrawer;

